module.exports = __webpack_public_path__ + "static/media/lk.497ee5b9.svg";